import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  MenuItem,
} from "@mui/material";
import { Form, Formik } from "formik";
import { formatDate } from "../../../../util/datetime";
import FormikTextField from "../../../commons/formik/FormikTextField";
import FormikSelect from "../../../commons/formik/FormikSelect";
import HeaderForm from "../../../commons/labels/HeaderForm";
import CircularLoading from "../../../commons/loading/CircularLoading";

const DialogIniciarPresentacion = ({ open, onClose, onSave, muestraVigente }) => {
  const loading = muestraVigente?.loading || false;
  const error = muestraVigente?.error || false;
  const data = muestraVigente?.data || {};

  const isSaveDisabled = loading || error || !data?.idMuestraProgramaPrevencion;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <HeaderForm title="Nueva Presentación Res. 81 (SVCC)" />

      {loading ? (
        <DialogContent sx={{ p: 3, pt: 2 }}>
          <CircularLoading />
        </DialogContent>
      ) : (
        <Formik
          enableReinitialize
          initialValues={{
            numeroMuestra: data?.numeroMuestra || "",
            tipoPresentacion: data?.tipoPresentacionSugerido || "",
            fechaInicioVigencia: formatDate(data?.fechaInicioVigencia) || "",
            fechaFinVigencia: formatDate(data?.fechaFinVigencia) || "",
            codigoPresentacionSRT: data?.codigoPresentacionSRT || "",
            fechaVencimientoEmpleador: formatDate(data?.fechaVencimientoEmpleador) || "",
          }}
          onSubmit={(values) => {
            onSave(values.tipoPresentacion);
          }}
        >
          {({ submitForm }) => (
            <Form>
              <DialogContent sx={{ p: 3, pt: 2, overflowY: "visible" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <FormikTextField
                      name="numeroMuestra"
                      label="Nro. Muestra"
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormikSelect
                      name="tipoPresentacion"
                      label="Tipo Presentación"
                      fullWidth
                    >
                      <MenuItem value={1}>Alta</MenuItem>
                      <MenuItem value={2}>Modificación</MenuItem>
                    </FormikSelect>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormikTextField
                      name="fechaInicioVigencia"
                      label="Vigencia Desde"
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormikTextField
                      name="fechaFinVigencia"
                      label="Vigencia Hasta"
                      disabled
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormikTextField
                      name="codigoPresentacionSRT"
                      label="Código Presentación"
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormikTextField
                      name="fechaVencimientoEmpleador"
                      label="Fecha Vencimiento Presentación"
                      disabled
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions sx={{ pr: 3, pb: 3 }}>
                <Button onClick={onClose} color="primary">
                  Cancelar
                </Button>
                <Button
                  onClick={submitForm}
                  disabled={isSaveDisabled}
                  color="primary"
                  variant="contained"
                >
                  Guardar
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};

export default DialogIniciarPresentacion;
